import { render } from "./AwardDetails.vue?vue&type=template&id=30d2ea47&scoped=true"
import script from "./AwardDetails.vue?vue&type=script&lang=js"
export * from "./AwardDetails.vue?vue&type=script&lang=js"

import "./AwardDetails.vue?vue&type=style&index=0&id=30d2ea47&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d2ea47"]])

export default __exports__